import { RSAA } from 'redux-api-middleware';
import { Actions } from '../actionTypes/actionTypes';
import type { RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import type { Selectors } from '../common/rootSelectors';
import { getSalesCheckinBffEndPoint } from '@makemydeal/dr-sales-checkin-ui-utils';
import type { GetState } from '../common/types/SalesCheckinRootState';
import { getDealerDetails, isAccelerateMyDealEnabled } from '../dealership/selector';
import { getActiveDeal } from '../activeDeal/selector';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { StateTree } from '@makemydeal/dr-dash-types';

export const getDealerDetailsData = (selectors: Selectors) => async (dispatch: any, getState: GetState) => {
    const state = getState();
    const environment = selectors.getEnvironment(state);
    const mmdId = getDealerDetails(state).dealerMMDId;
    const endpoint = getSalesCheckinBffEndPoint(`dealers/${mmdId}`, environment);
    const request: RSAACallRequest = {
        endpoint,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        types: [Actions.GET_DEALER_DETAILS_REQUEST, Actions.GET_DETAILS_SUCCESS, Actions.GET_DEALER_DETAILS_FAILURE],
        fetch: async (...args) => await fetch(...args)
    };
    // Returned so callers that need the dealer settings before proceeding (e.g. re-evaluating the
    // workflow right after a role-assumption dealership auto-resolves) can await it.
    return dispatch({ [RSAA]: request });
};

export const getDeepLinkUrls = (selectors: Selectors) => async (dispatch: any, getState: GetState) => {
    const state = getState();
    // Get dealXgId from active deal if it exists, otherwise use placeHolderDealXgId from check-in
    const dealXgId = getActiveDeal(state).dealId;

    // Don't make the API call if dealXgId is still undefined
    if (!dealXgId) {
        return;
    }

    const environment = selectors.getEnvironment(state);
    const basePath = `/deals/${dealXgId}/deep-links`;
    const isAmdShareLinkToggleEnabled = !!featureToggleSelectors.isAmdShareLinkEnabled(state as unknown as StateTree);
    const endpoint = getSalesCheckinBffEndPoint(
        isAmdShareLinkToggleEnabled ? `${basePath}?isAmdEnabledDealer=${isAccelerateMyDealEnabled(state)}` : basePath,
        environment
    );
    const request: RSAACallRequest = {
        endpoint: endpoint,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        types: [Actions.ADD_DEEPLINK_URL_REQUEST, Actions.ADD_DEEPLINK_URL_SUCCESS, Actions.ADD_DEEPLINK_URL_FAILURE],
        fetch: async (...args) => await fetch(...args)
    };
    dispatch({ [RSAA]: request });
};
